"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsPanel = exports.ACTIVE_FILTER_TYPES = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const partials_1 = require("./partials");
const settings_panel_styles_1 = require("./settings-panel.styles");
const feature_flags_1 = require("../../../../feature-flags");
const hooks_1 = require("../../../../hooks");
const localization_1 = require("../../../../localization");
const state_1 = require("../../../../store/state");
exports.ACTIVE_FILTER_TYPES = [
    state_1.ProductFilterActiveTypes.All,
    state_1.ProductFilterActiveTypes.Active,
    state_1.ProductFilterActiveTypes.Inactive,
];
const REFINEMENTS_FILTER_TYPES = [state_1.AvailableRefinementType.All, state_1.AvailableRefinementType.Matches];
const PRODUCT_FILTER_OPERATOR = [state_1.ProductFilterOperatorType.And, state_1.ProductFilterOperatorType.Or];
const SettingsPanel = ({ activeFilter, availableRefinementsFilter, onSearchTermChange, onChangeFilter, onChangeFilterOperator, onRefinementsFilter, onSetOrganization, organizations, resetSettingSelections, resultsFilter, debouncedSearchTerm: search, selectedOrganization, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { featureFlagsService } = (0, hooks_1.useFeatureFlagsService)();
    const isProductCountsEnabled = featureFlagsService.isFeatureEnabled(feature_flags_1.FeatureFlag.ProductCounts);
    const [searchTerm, setSearchTerm] = (0, react_1.useState)(search !== null && search !== void 0 ? search : '');
    const handleUpdateSearchTerm = (value) => {
        setSearchTerm(value);
        onSearchTermChange(value);
    };
    const handleSearchTermChange = (event) => handleUpdateSearchTerm(event.target.value);
    const handleSearchTermClear = () => handleUpdateSearchTerm('');
    (0, react_1.useEffect)(() => {
        setSearchTerm(search !== null && search !== void 0 ? search : '');
    }, [search]);
    return (react_1.default.createElement(settings_panel_styles_1.StyledSettingsWrapper, null, react_1.default.createElement(settings_panel_styles_1.StyledSettingsHeader, null, react_1.default.createElement(settings_panel_styles_1.StyledSettingsTitleText, null, t({ key: 'SETTINGS' })), react_1.default.createElement(settings_panel_styles_1.StyledResetButton, { title: t({ key: 'RESET' }), size: "small", onClick: resetSettingSelections })), react_1.default.createElement(settings_panel_styles_1.StyledButtonsWrapper, null, react_1.default.createElement(partials_1.OrganizationSelector, { organizations: organizations, selectedOrganization: selectedOrganization, selectOrganization: onSetOrganization })), react_1.default.createElement(settings_panel_styles_1.StyledButtonsWrapper, null, react_1.default.createElement(settings_panel_styles_1.StyledButtonsHeader, null, t({ key: 'PRODUCTS' })), react_1.default.createElement(settings_panel_styles_1.StyledToggleButtons, { options: exports.ACTIVE_FILTER_TYPES.map((activeFilterType) => ({
            title: t({ key: activeFilterType }),
            value: activeFilterType,
        })), value: activeFilter, onChange: (_event, value) => {
            if (value)
                onChangeFilter(value);
        }, size: "small", exclusive: true })), isProductCountsEnabled ? react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(settings_panel_styles_1.StyledButtonsWrapper, null, react_1.default.createElement(settings_panel_styles_1.StyledButtonsHeader, null, t({ key: 'VIEW' })), react_1.default.createElement(settings_panel_styles_1.StyledToggleButtons, { options: REFINEMENTS_FILTER_TYPES.map((refinementsFilterType) => ({
            title: t({ key: refinementsFilterType }),
            value: refinementsFilterType,
        })), value: availableRefinementsFilter, onChange: (_event, value) => {
            if (value)
                onRefinementsFilter(value);
        }, size: "small", radioGroupMode: true, exclusive: true }))) : null, react_1.default.createElement(settings_panel_styles_1.StyledButtonsWrapper, null, react_1.default.createElement(settings_panel_styles_1.StyledButtonsHeader, null, t({ key: 'RESULTS' })), react_1.default.createElement(settings_panel_styles_1.StyledToggleButtons, { options: PRODUCT_FILTER_OPERATOR.map((activeResultType) => ({
            title: t({ key: activeResultType }),
            value: activeResultType,
        })), value: resultsFilter, onChange: (_event, value) => {
            if (value)
                onChangeFilterOperator(value);
        }, size: "small", className: "and-or", exclusive: true })), react_1.default.createElement(material_1.Divider, { variant: "middle" }), react_1.default.createElement(partials_1.SearchInput, { handleSearchTermChange: handleSearchTermChange, searchTerm: searchTerm, handleSearchTermClear: handleSearchTermClear })));
};
exports.SettingsPanel = SettingsPanel;
